const thumbnailTdo = thumbnail => thumbnail?.fields?.file?.url || "";
export default thumbnailTdo;
